import React from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useAuth } from "@/lib/auth";
import { Building2, Mail, Shield, KeyRound } from "lucide-react";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="space-y-6 max-w-3xl">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Settings</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Profile & Workspace</h1>
      </div>
      <Card className="border-border shadow-none p-6">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-gradient-to-br from-[#0047AB] to-[#4338CA] text-white grid place-items-center font-bold text-2xl">{user?.name?.[0]}</div>
          <div>
            <h2 className="font-display text-2xl font-bold tracking-tight">{user?.name}</h2>
            <div className="text-sm text-muted-foreground flex items-center gap-2 mt-1"><Mail className="h-3.5 w-3.5" /> {user?.email}</div>
            <div className="mt-2 flex gap-2">
              <Badge className="bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-50 font-mono text-[10px] tracking-wider uppercase">{user?.role}</Badge>
              {user?.org && <Badge variant="outline" className="font-mono text-[10px] tracking-wider"><Building2 className="h-3 w-3 mr-1" />{user.org}</Badge>}
            </div>
          </div>
        </div>
      </Card>
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="border-border shadow-none p-6">
          <Shield className="h-5 w-5 text-emerald-600 mb-3" />
          <h3 className="font-display text-lg font-bold tracking-tight">Security</h3>
          <p className="text-sm text-muted-foreground mt-1">Password rotation, MFA enrollment, session policies.</p>
          <div className="mt-4 space-y-2 text-sm">
            <div className="flex items-center justify-between p-3 border border-border rounded-md">
              <span>Two-factor auth</span><Badge variant="outline">Not enrolled</Badge>
            </div>
            <div className="flex items-center justify-between p-3 border border-border rounded-md">
              <span>Password last changed</span><span className="text-muted-foreground">Never</span>
            </div>
          </div>
        </Card>
        <Card className="border-border shadow-none p-6">
          <KeyRound className="h-5 w-5 text-[#0047AB] mb-3" />
          <h3 className="font-display text-lg font-bold tracking-tight">API Keys</h3>
          <p className="text-sm text-muted-foreground mt-1">Programmatic access for integrations.</p>
          <div className="mt-4 p-3 border border-dashed border-border rounded-md text-sm text-muted-foreground text-center">
            No keys yet — Enterprise plan feature.
          </div>
        </Card>
      </div>
    </div>
  );
}
